"use strict";
exports.__esModule = true;
var version = "1.4.10";
exports["default"] = version;
